// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__lLFDi","left":"styles_left__1oq-9"};